export type ReferralsState = {
  referrals: {
    isDriverEligible: boolean;
  };
};

const FETCH_REFERRALS_ELIGIBILITY_BEGIN = 'account/Referrals/FETCH_REFERRALS_ELIGIBILITY_BEGIN';
const FETCH_REFERRALS_ELIGIBILITY_SUCCESS = 'account/Referrals/FETCH_REFERRALS_ELIGIBILITY_SUCCESS';
const FETCH_REFERRALS_ELIGIBILITY_ERROR = 'account/Referrals/FETCH_REFERRALS_ELIGIBILITY_ERROR';
const UPDATE_REFERRALS_DISPLAY_TOGGLE = 'account/Referrals/UPDATE_REFERRALS_DISPLAY_TOGGLE';

export {
  FETCH_REFERRALS_ELIGIBILITY_BEGIN,
  FETCH_REFERRALS_ELIGIBILITY_SUCCESS,
  FETCH_REFERRALS_ELIGIBILITY_ERROR,
  UPDATE_REFERRALS_DISPLAY_TOGGLE
};
